import {
  WORK_MODULES,
  getModuleEntryPath,
  getModuleInicioPath,
  setStoredWorkModule,
} from "@/modules/workModuleCore";

/**
 * Entrada desde Panel General / selector de módulos.
 * Diseñador comercial exige modo Distribuidor; platform_designer usa Modo Plataforma BNT.
 */
export async function enterWorkModuleFromHub({
  cardId,
  navigate,
  canSwitch,
  setWorkspaceMode,
  isPlatformDesigner = false,
}) {
  const workModule = cardId;

  if (
    workModule === WORK_MODULES.VISOR_SAT
    || workModule === WORK_MODULES.ASISTENTE_LABORAL
    || workModule === WORK_MODULES.TRAMITES_FISCALES
    || workModule === WORK_MODULES.GESTION_DESPACHO
    || workModule === WORK_MODULES.MATERIALIDAD
    || workModule === WORK_MODULES.DISENADOR
  ) {
    setStoredWorkModule(workModule);
  }

  if (workModule === WORK_MODULES.DISENADOR) {
    if (!isPlatformDesigner && canSwitch && typeof setWorkspaceMode === "function") {
      await setWorkspaceMode("distribuidor");
    }
    navigate(getModuleInicioPath(WORK_MODULES.DISENADOR));
    return workModule;
  }

  navigate(getModuleEntryPath(cardId));
  return workModule;
}
